import { render, staticRenderFns } from "./ItemsControl.vue?vue&type=template&id=1fda6708&scoped=true&"
import script from "./ItemsControl.vue?vue&type=script&lang=js&"
export * from "./ItemsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fda6708",
  null
  
)

export default component.exports